/**
 * Regional market country code constants
 *
 * Library (src/screens/Library/constants/library.constants.ts) is the source of truth
 * for EU and MENA country membership. This file derives shared code arrays from it so
 * that both Library and Events stay in sync from one place.
 *
 * Turkey (TR) is exported standalone because its region assignment differs by context:
 *   - Library: Turkey is in Europe
 *   - Events:  Turkey is in MENA
 */

export const TURKEY = 'TR'

/** Library-standard EU country codes (includes Turkey) */
export const LIBRARY_EU_COUNTRY_CODES: string[] = [
  'AT', 'BE', 'BG', 'HR', 'CY', 'CZ', 'DK', 'EE', 'FI', 'FR',
  'DE', 'GR', 'HU', 'IS', 'IE', 'IT', 'LV', 'LT', 'LU', 'MT',
  'NL', 'NO', 'PL', 'PT', 'RO', 'SK', 'SI', 'ES', 'SE', 'CH',
  TURKEY, 'GB',
]

/** Library-standard MENA country codes (excludes Turkey) */
export const LIBRARY_MENA_COUNTRY_CODES: string[] = [
  'DZ', 'BH', 'EG', 'JO', 'KE', 'KW', 'MA', 'OM', 'SA', 'AE',
]

/**
 * Event module EU country codes
 * Inherits from Library EU, Turkey excluded (Turkey is in EVENT_MENA_COUNTRY_CODES for events)
 */
export const EVENT_EU_COUNTRY_CODES: string[] = LIBRARY_EU_COUNTRY_CODES.filter(
  code => code !== TURKEY
)

/**
 * Event module MENA country codes
 * Inherits from Library MENA, plus Turkey (events-specific placement) and ZA (events-specific market)
 */
export const EVENT_MENA_COUNTRY_CODES: string[] = [...LIBRARY_MENA_COUNTRY_CODES, TURKEY, 'ZA']

/** Market country code map used by the event module */
export const REGION_COUNTRIES: Record<string, string[]> = {
  eu: EVENT_EU_COUNTRY_CODES,
  mena: EVENT_MENA_COUNTRY_CODES,
}
